import initializeExtensibilityContext from './initializeExtensibilityContext';
import runContextualEvaluation from './runContextualEvaluationAndUpdate';
import { isContextualScenario } from './ContextualChecker';
import { isPersistentTaskpaneEnabled } from 'owa-addins-feature-flags';
import { populatePersistedAddins } from 'owa-addins-persistent';
import {
    initializeExtensibilityHostItem,
    whenExtensibilityContextInitialized,
} from 'owa-addins-store';
import {
    lazyInitializeExtensibilityFrameworkComponent,
    onItemNavigation,
    SelectionType,
} from 'owa-addins-view';
import {
    addAdapter,
    initializeExtensibilityNotifications,
    MessageComposeAdapter,
    MessageReadAdapter,
} from 'owa-addins-apis';

/** @param renderTaskPaneInPanel This should be called with the same value everywhere in the application */
export default async function initializeAddinsForItem(
    index: string,
    adapter: MessageComposeAdapter | MessageReadAdapter,
    renderTaskPaneInPanel: boolean = true
) {
    addAdapter(index, adapter);
    initializeExtensibilityHostItem(index);
    if (isContextualScenario(adapter.mode)) {
        const readAdapter = adapter as MessageReadAdapter;
        whenExtensibilityContextInitialized(initializeContextualTerms(readAdapter, index));
    }
    initializeExtensibilityNotifications(index);
    lazyInitializeExtensibilityFrameworkComponent(renderTaskPaneInPanel);
    await populatePersistedAddins(adapter.mode);
    await initializeExtensibilityContext();
    isPersistentTaskpaneEnabled() && onItemNavigation(SelectionType.Single, index);
}

function initializeContextualTerms(readAdapter: MessageReadAdapter, index: string): () => void {
    return () => runContextualEvaluation(readAdapter.getItem(), index);
}
